import { Navigate } from "react-router-dom";
import { useAppSelector } from "@/src/redux/hooks";
import { STORAGE_KEYS } from "@/src/constants/storageKeys";

function hasAuthCookie(): boolean {
  if (typeof document === "undefined") return false;
  return document.cookie.split(";").some((part) => {
    const [name, value] = part.trim().split("=");
    return name === STORAGE_KEYS.AUTH_COOKIE && Boolean(value);
  });
}

export default function HomeRedirect() {
  const accessToken = useAppSelector((state) => state.auth.accessToken);
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  if (isAuthenticated && accessToken) {
    return <div className="min-h-screen bg-bg-base" />;
  }

  if (hasAuthCookie()) {
    return <Navigate to="/assets" replace />;
  }

  return <Navigate to="/splash" replace />;
}
